import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { LoginReasonsType } from '~login/services/login.service';

export const LoginActions = createActionGroup({
  source: 'Auth',
  events: {
    'Login': props<{ email: string; password: string }>(),
    'Login Success': props<{ token: string }>(),
    'Login Failure': props<{ error: LoginReasonsType | string }>(),
    'Logout': emptyProps(),
  }
});
